export enum Sources {
  UNKNOWN_SOURCE = "UNKNOWN_SOURCE",
  AUTO_POPULATED = "AUTO_POPULATED",
  EHR_GENERATED = "EHR_GENERATED",
  USER_CREATED = "USER_CREATED",
  QVENTUS_SUGGESTED = "QVENTUS_SUGGESTED",
}
